import PropTypes from "prop-types";
import React from "react";
import { FileField, FileInput, useNotify } from "react-admin";
import SaveFile from "../../SaveFile";
import "./UploadFile.css";
import { FileAcceptWhiteList } from "../../Constants/Constant";
import { Box } from "@material-ui/core";

const UploadFile = ({
  disabled,
  disabledText = "Please select a file type first to upload a file.",
  label,
  multiple,
  placeholder,
  setIsLoading,
  onHandleFileExecute,
  object,
  source,
}) => {
  const notify = useNotify();

  const handleFileChange = fileObj => {
    setIsLoading?.(true);

    let file: File = fileObj[0];
    SaveFile(file, { object, source, onHandleFileExecute })
      .then((object: any) => {
        notify("File upload success.", "success");
        onHandleFileExecute?.();
      })
      .finally(() => setIsLoading?.(false));
  };

  if (disabled) {
    return (
      <Box
        style={{
          padding: "8px",
          textAlign: "center",
          backgroundColor: "#fafafa",
          margin: "10px 0",
        }}
      >
        <p>{disabledText}</p>
      </Box>
    );
  }

  return (
    <FileInput
      source="src"
      label={label}
      multiple={multiple}
      placeholder={placeholder}
      options={{ onDrop: handleFileChange }}
      accept={FileAcceptWhiteList}
      RaFileInput={false}
    >
      <FileField source="src" title="title" />
    </FileInput>
  );
};

UploadFile.propTypes = {
  label: PropTypes.string,
  multiple: PropTypes.bool,
  onHandleFileExecute: PropTypes.func,
  source: PropTypes.string,
  object: PropTypes.object,
  placeholder: PropTypes.string,
  setIsLoading: PropTypes.func,
  disabled: PropTypes.bool,
  disabledText: PropTypes.string,
};

export default UploadFile;
